import React from "react";
import {SafetyCertificateOutlined} from "@ant-design/icons";
import {Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import SectionCard from "../../common/sectionCard/SectionCard";
import pillStyles from "../styles/pills.module.scss";
import styles from "../styles/results.module.scss";

function renderDerivedBlock(title, value) {
    const entries = value && typeof value === "object" ? Object.entries(value).filter(([, entryValue]) => entryValue !== null && entryValue !== undefined && entryValue !== "") : [];

    return (
        <div className={styles.derivedBlock}>
            <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={styles.derivedTitle}>
                {title}
            </Text>
            {entries.length ? (
                entries.map(([key, entryValue]) => (
                    <Text key={key} as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.derivedRow}>
                        <span className={styles.derivedKey}>{key.replace(/_/g, " ")}:</span> {typeof entryValue === "object" ? JSON.stringify(entryValue) : String(entryValue)}
                    </Text>
                ))
            ) : (
                <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.emptyNote}>
                    Nothing derived.
                </Text>
            )}
        </div>
    );
}

/**
 * Full-manual-flow outcome: the identity / employment / income the batch
 * would have written, with a VERIFIED pill when the run qualified. All keys
 * optional — a rejected batch renders its empty blocks honestly.
 *
 * @param {Object} props
 * @param {Object} [props.batchAnalysis] — report `batch_analysis`
 * @param {boolean} [props.accepted] — report `result.accepted`
 */
function DerivedOutcomeCard({batchAnalysis, accepted}) {
    if (!batchAnalysis) return null;

    return (
        <SectionCard
            icon={<SafetyCertificateOutlined />}
            title="Derived Outcome"
            action={
                <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${pillStyles.tag} ${accepted ? pillStyles.tone_success : pillStyles.tone_neutral}`}>
                    {accepted ? "Would be verified" : "Not verified"}
                </Text>
            }>
            <div className={styles.derivedGrid}>
                {renderDerivedBlock("Identity", batchAnalysis.derived_identity)}
                {renderDerivedBlock("Employment", batchAnalysis.derived_employment)}
                {renderDerivedBlock("Income", batchAnalysis.derived_income)}
            </div>
        </SectionCard>
    );
}

export default DerivedOutcomeCard;
